import { useContext, useState, useEffect } from "react";
import { PageContext, PageValue } from "../contexts/page";

const getStateType = (typeRef, block) => {
  if (!typeRef) {
    return null;
  }
  const path = typeRef.split(".");
  let value = { ...block.props };
  let usePropValue = false;
  path.forEach((p) => {
    if (value[p]) {
      value = value[p];
      usePropValue = true;
    } else {
      usePropValue = false;
    }
  });
  if (usePropValue) {
    return value;
  } else {
    return null;
  }
};

export default function useStateTypes() {
  const tree = useContext(PageValue);
  const [types, setTypes] = useState([]);

  useEffect(() => {
    if (tree) {
      const _types = [];
      const getStateTypes = (block) => {
        if (block.stateVariables) {
          const fields = {};
          block.stateVariables.forEach((s) => {
            fields[s.value] = {
              name: s.displayName,
              list: s.list,
              type: getStateType(s.typeRef, block)
                ? getStateType(s.typeRef, block)
                : s.type,
            };
          });
          _types.push({
            name: block.id ? block.id : "page",
            type: "element",
            dispayName: block.name,
            fields: fields,
          });
        }

        if (block.children.length > 0) {
          block.children.forEach((b) => {
            getStateTypes(b);
          });
        }
      };
      getStateTypes(tree);
      setTypes(_types);
    }
  }, [tree]);

  return types;
}
